import React from "react";
import { isMobile } from "react-device-detect";
import { WebLoderTop } from "../../config/config";
import "../../styles/css/common-loader.css";

function Loader({ margin = "auto", MarginTop = "auto" }) {
  return (
    <div
      style={{
        position: "absolute",
        top: isMobile ? 0 : WebLoderTop,
        left: 0,
        right: 0,
        bottom: 0,
        margin: margin,
        marginTop: MarginTop,
      }}
      className="newLoader"
      aria-label="Loading"
      role="progressbar"
    />
  );
}
export default Loader;
